import { Courses } from './_components/courses'

export function AvailableCourses() {
	return <Courses />
}
